import styled from "styled-components";

import { Link } from "react-router-dom";

import { theme } from "../../../styles/theme";

interface MenuProps {
  open: boolean;
  selected: boolean;
}

export const MenuItemsElement = styled(Link) <MenuProps>`
  width: ${({ open }) => (open ? "100%" : "80%")};
  margin-left: 7px;
  color: white;
  display: flex;
  font-family: ${theme.font.poppins};
  font-size: 0.9em;
  align-items: center;
  cursor: pointer;
  height: 45px;
  justify-content: ${({ open }) => (open ? "flex-start" : "center")};
  margin-bottom: 5px;
  border-radius: 10px;
  text-decoration: none;
  background-color: ${({ selected }) => selected && theme.colors.primary};
  color: ${({ selected }) => (selected ? "#E5E5E5" : theme.colors.blue400)};
  padding: 0 10px;

  transition: width 0.3s ease, justify-content 0.3s ease,
    background-color 0.3s ease, color 0.3s ease;

  svg,
  path {
    max-width: 25px;
    width: 100%;
    fill: ${({ selected }) => (selected ? "#fff" : theme.colors.primary)};
  }

  &:hover {
    background: ${theme.colors.lightGray};
    transition: background 0.3s ease, color 0.3s ease;
    color: ${theme.colors.primary};

    svg,
    path {
      fill: ${theme.colors.primary};
    }

    span {
      font-size: 0.9em;
      color: ${theme.colors.primary};
    }
  }
`;

export const MenuSpanElement = styled.span<MenuProps>`
  display: block;
  color: ${theme.colors.white};
  font-size: 15px;
  margin-left: ${({ open }) => (open ? "10px" : "2px")};
  font-size: 0.9em;
  transition: margin-left 0.3s ease, color 0.3s ease;
  white-space: nowrap;

  &:hover {
    color: ${theme.colors.primary};

    .svg {
      fill: ${theme.colors.primary};
      background-color: #e5e5e5;
    }
  }
`;
